<template>
  <div class="animated fadeIn row">
    <nav class="navbar navbar-light bg-light w-full" style="padding: .5rem 1rem;margin-top: -20px;">
      <a class="navbar-brand" href="#"><b>โปรโมชั่น 
        <span v-bind:class="'flag-icon flag-icon-us'" v-if="covertoLowerCase(lang)=='en'"></span>
        <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(lang)" v-if="covertoLowerCase(lang)!='en'"></span>
        </b></a>
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <router-link :to="{ name: 'PromotionAdd'}"><button class="btn btn-lg btn-primary" type="button"><i class="fas fa-plus"></i>
              เพิ่ม</button></router-link>
        </li>
      </ul>
    </nav>
    <div v-for="valuePromotion in data.promotions" class="card col-md-12" :key="valuePromotion.id">
      <div class="card-body">
        <div class="row bd-example2">
          <div class="col-sm-12 col-lg-4">
            <img v-bind:src="valuePromotion.image" @error="imageLoadError" class="d-block w-full">
          </div>          
          <div class="col-sm-12 col-lg-8">
            <div id="spy-example2" data-spy="scroll" data-target="#list-example" data-offset="0">
              <h4 class="text-center">
                <b v-html="valuePromotion.title"></b> <span v-if="valuePromotion.hidden" class="badge badge-danger" style="margin-left: 10px;">ไม่แสดง</span>
              </h4>
              <label v-if="valuePromotion.created_at">&nbsp;&nbsp;<b>วันที่สร้าง:</b> {{ valuePromotion.created_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
              <label v-if="valuePromotion.updated_at">&nbsp;&nbsp;<b>วันที่แก้ไข:</b> {{ valuePromotion.updated_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
              <label v-if="valuePromotion.expired_at">&nbsp;&nbsp;<b>วันที่หมดอายุ:</b> {{ valuePromotion.expired_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
              
              <div class="col-sm-12" v-if="valuePromotion.description!=''" style="overflow: hidden">
                <p>
                  <span v-html="valuePromotion.description"></span>
                </p>
              </div>
              <span class="badge badge-info"><span v-if="valuePromotion.new_price&&valuePromotion.new_price!=''">ลดราคาเหลือ {{valuePromotion.new_price}}</span><span v-if="valuePromotion.old_price&&valuePromotion.old_price!=''"> จากราคา {{valuePromotion.old_price}}</span></span>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="col-sm-12 col-lg-12 row">
              <div class="col-sm-12 col-lg-4">
                  <div class="col-sm-12 col-lg-12 row">
                    <div class="ml-4" v-for="valueLang of valuePromotion.languages" :key="valueLang">
                      <span style="margin-top: 1em;" v-bind:class="'btn-lg flag-icon flag-icon-us'" v-if="covertoLowerCase(valueLang)=='en'"></span>
                      <span style="margin-top: 1em;" v-bind:class="'btn-lg flag-icon flag-icon-'+covertoLowerCase(valueLang)" v-if="covertoLowerCase(valueLang)!='en'"></span>
                    </div>
                  </div>
              </div>
              <div class="col-sm-12 col-lg-8">
                  <div class="row">
                    <div class="col-lg-4 col-sm-4">
                      <a target="_blank" style="text-decoration: none" v-bind:href="site_url.src+'promotions/'+valuePromotion.slug+'-'+valuePromotion.id">
                        <b-btn class="mt-3" variant="outline-primary" block><i class="fas fa-eye"></i> แสดงตัวอย่าง</b-btn>
                      </a>
                    </div>
                    <div class="col-lg-4 col-sm-4">
                      <b-btn @click="$router.push({ name: 'PromotionEdit',params: { id: valuePromotion.id }})" class="mt-3"
                        variant="outline-primary" block><i class="fas fa-edit"></i> แก้ไข</b-btn>
                    </div>
                    <div class="col-lg-4 col-sm-4">
                      <b-btn @click="alertDeletePromotion(valuePromotion.id,valuePromotion.title)" class="mt-3" variant="outline-primary"
                        block><i class="fas fa-trash-alt"></i> ลบ</b-btn>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="promotion.alert.title" ref="alert" hide-footer v-model="promotion.alert.active" @ok="promotion.alert.active = false">
      <div v-if="promotion.alert.load==false">
        <div class="row">
          <div class="col-md-12 text-center">
            <span v-html="promotion.alert.detail"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="promotion.alert.open.active">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitDelete"><span v-html="promotion.alert.open.name"></span></b-btn>
          </div>
          <div class="col-lg-3" v-if="promotion.alert.open.active==false"></div>
          <div class="col-lg-6" v-if="promotion.alert.close.active">
            <b-btn class="mt-3" variant="outline-secondary" block @click="closeAlert"><span v-html="promotion.alert.close.name"></span></b-btn>
          </div>
        </div>
      </div>
      <div v-if="promotion.alert.load">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
    <div v-if="data.per_page&&data.per_page!=null&&data.per_page>1" class="w-full">
      <b-pagination align="center" :total-rows="data.per_page*data.per_page" v-on:input="getPromotions" v-model="data.page"
        :per-page="data.per_page"></b-pagination>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        site_url:{
          src: localStorage.getItem('z_site_url')
        },
        no_image:{
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        promotion: {
          id: null,
          name: '',
          alert: {
            title: '',
            open: {
              active: false,
              name: ''
            },
            close: {
              active: false,
              name: ''
            },
            image: null,
            action: '',
            detail: '',
            active: false,
            load: false
          }
        },
        lang: this.$route.query.lang,
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          page: this.$route.query.page,
          per_page: null,
          promotions: {}
        }
      }
    },
    mounted() {
      if(!this.lang){
        this.lang = 'th'
      }
      this.checkLang()
      this.startLoad(1)
      this.getPromotions()
    },
    methods: {
      covertoLowerCase(title){
        if(title&&title!=''){
          return title.toLowerCase()
        }else{
          return title
        }
      },
      checkLang(){
        if(!this.lang){
          this.lang='th'
        }
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      closeAlert() {
        this.$refs.alert.hide()
      },
      alertDeletePromotion(promotionID, promotionName) {
        this.promotion.id = promotionID
        this.promotion.name = promotionName
        this.promotion.alert.title = 'การลบโปรโมชั่น'
        this.promotion.alert.detail = 'คุณต้องการลบโปรโมชั่น "<b>' + promotionName + '</b>" ใช่หรือไม่?'
        this.promotion.alert.open.active = true
        this.promotion.alert.close.active = true
        this.promotion.alert.open.name = 'ยืนยันการลบ'
        this.promotion.alert.close.name = 'ยกเลิกการลบ'
        this.promotion.alert.active = true
      },
      submitDelete() {
        this.promotion.alert.load = true
        this.deletePromotionByID()
      },
      getPromotions() {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/promotions', {
          params: {
            page: this.data.page,
            per_page: this.data.per_page,
            lang: this.lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          this.lang = response.data.json.lang
          this.checkLoad()
          moment.locale(this.lang)
            this.data.page = parseInt(response.data.json.page)
            this.data.per_page = parseInt(response.data.json.per_page)
            this.$router.replace({ name: 'PromotionList',query: { page: this.data.page,lang: this.lang }})
          this.data.promotions = response.data.json.data
        }).catch(function (error) {
          this.failLoad()
          this.promotion.alert.title = 'การดึงข้อมูลโปรโมชั่น'
          this.promotion.alert.detail = 'ไม่สามารถทำการดึงโปรโมชั่นได้!'
          this.promotion.alert.open.active = false
          this.promotion.alert.close.name = 'ปิด'
          this.promotion.alert.active = true
        })
      },
      deletePromotionByID() {
        if (this.promotion.id && this.promotion.id != '') {
          this.startLoad(2)
          this.$http.delete(process.env.VUE_APP_API_URL + 'api/v1/promotion/' + this.promotion.id, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.checkLoad()
            this.promotion.alert.load = false
            this.getPromotions()
            this.promotion.alert.detail = 'ทำการลบโปรโมชั่นหมายเลข: ' + response.body.json.promotion.id + ' เรียบร้อย'
            this.promotion.alert.open.active = false
            this.promotion.alert.close.name = 'ปิด'
            this.promotion.alert.active = true
          }).catch(function (error) {
            this.failLoad()
            this.promotion.alert.detail = 'ไม่สามารถทำการลบโปรโมชั่นได้!'
            this.promotion.alert.open.active = false
            this.promotion.alert.close.name = 'ปิด'
            this.promotion.alert.active = true
          })
        }
      },
      imageLoadError(event){
        event.target.src = this.no_image.src
      }
    }
  }

</script>
